"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _reactLazyLoad = _interopRequireDefault(require("react-lazy-load"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _LoadingAnimation = require("../LoadingAnimation");
var _Text = require("../Text");
var _theme = require("../utils/theme");
var _animations = require("@qwkin/animations");
var _templateObject;
var AnimatedLazyLoad = (0, _styledComponents["default"])(_reactLazyLoad["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  animation: ", " 0.5s;\n  ", "\n"])), _animations.fadeIn, function (p) {
  return p.extended ? 'width: 100%;' : '';
});
var DefaultComponent = /*#__PURE__*/_react["default"].createElement(_Text.Text, {
  type: "small",
  color: "#999999"
}, "No default component passed");
var DefaultErrorComponent = /*#__PURE__*/_react["default"].createElement(_Text.Text, {
  type: "small",
  color: _theme.defaultTheme.color.danger
}, "Error loading component");
var AsyncComponent = function AsyncComponent(_ref) {
  var _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? true : _ref$loading,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    _ref$component = _ref.component,
    component = _ref$component === void 0 ? DefaultComponent : _ref$component,
    _ref$errorComponent = _ref.errorComponent,
    errorComponent = _ref$errorComponent === void 0 ? DefaultErrorComponent : _ref$errorComponent,
    _ref$loadingSize = _ref.loadingSize,
    loadingSize = _ref$loadingSize === void 0 ? 80 : _ref$loadingSize,
    _ref$extended = _ref.extended,
    extended = _ref$extended === void 0 ? false : _ref$extended;
  return loading ? /*#__PURE__*/_react["default"].createElement(_LoadingAnimation.LoadingAnimation, {
    width: loadingSize,
    height: loadingSize
  }) : error ? /*#__PURE__*/_react["default"].createElement(AnimatedLazyLoad, {
    extended: extended
  }, /*#__PURE__*/_react["default"].cloneElement(errorComponent)) : /*#__PURE__*/_react["default"].createElement(AnimatedLazyLoad, {
    extended: extended
  }, /*#__PURE__*/_react["default"].cloneElement(component));
};
var _default = exports["default"] = AsyncComponent;